import React, { useMemo } from "react";
import { Animated, Easing } from "react-native";
import { useTransitioningValue } from "./hooks/useTransitioningValue.js";
const defaultDurationMillis = 150;
export default function FadeView(props) {
    const { isVisible, durationMillis = defaultDurationMillis, onTransitionEnd, delayMillis = 0, removeFromLayoutWhenHidden, style, } = props;
    const [lastCompletedVisibility, setLastCompletedVisibility] = React.useState(props.isVisible);
    const opacity = useTransitioningValue({
        value: isVisible ? 1 : 0,
        timing: {
            type: "timing",
            easing: Easing.linear,
            duration: durationMillis,
            delay: delayMillis,
            useNativeDriver: true,
        },
        onEndCallback: ({ finished }) => {
            setLastCompletedVisibility(isVisible);
            return onTransitionEnd?.(isVisible, finished);
        },
    });
    const shouldRemoveFromLayout = !lastCompletedVisibility && !isVisible && removeFromLayoutWhenHidden;
    return (<Animated.View style={useMemo(() => [
            style,
            {
                opacity,
                ...(!isVisible && { pointerEvents: "none" }),
                ...(shouldRemoveFromLayout && { display: "none" }),
            },
        ], [isVisible, opacity, shouldRemoveFromLayout, style])}>
      {props.children}
    </Animated.View>);
}
//# sourceMappingURL=FadeView.js.map